
    import {defineComponent, reactive} from 'vue'

    interface State {
        sealType: string; // 是否有闲鱼优品印章
    }

    export default defineComponent({
        name: "reminder",
        setup() {
            let state: State = reactive({
                sealType: '',
            })
            return {
                state
            }
        },
        methods: {}
    })
